// extracted by mini-css-extract-plugin
module.exports = {"section-label":"section-label__section-label___3L6kB","no-bottom-border":"section-label__no-bottom-border___KoPQH","no-bottom-margin":"section-label__no-bottom-margin___Qy8bp"};